import SettingProfileCard from "./components/Account/SettingProfileCard";
import Setting from "./view/Setting";
import Dashboard from "../dashboard/modules/dashboard/views/dashboardLayout.vue";
import { Auth } from "@brainspore/celadon-base/modules/auth";
const SettingRoutes = [
  {
    path: "",
    name: "",
    component: Dashboard,
    children: [
      {
        path: "/settings",
        name: "Setting",
        component: Setting,
        children: [
          {
            path: "account-settings",
            name: "AccountSettings",
            component: SettingProfileCard,
            meta: { middleware: [Auth] },
          },
        ],
      },
    ],
  },
];
export default SettingRoutes;
